<template>
  <div class="rcpx">
    <div class="banners">
      <div class="w1280">
        <div class="t1">数据标注职业技能人才培训</div>
        <div class="t2">助 力 职 业 技 能 权 威 认 证 证 书</div>
        <div class="t2">为 你 的 人 生 添 加 一 条 有 潜 力 的 就 业 道 路</div>
        <div class="btns" @click="go('/callMe')">点击了解更多</div>
      </div>
    </div>
    <div class="w1280">
      <div class="title-bg">
        <div class="title">行业空间</div>
      </div>
      <div class="flexs">
        <div class="left-s">
          <img style="width: 100%;" src="../assets/img/rcpx/t1.png" alt="" />
        </div>
        <div class="right-s">
          <div class="t3">市场需求量大</div>
          <div class="t4">数据标注项目量持续增加，市场需求不断递增。</div>
          <div class="t3">发展空间广</div>
          <div class="t4">
            AI发展迅猛，数据标注作为其入门级岗位，未来有更多可能性。
          </div>
          <div class="t3">行业规范化</div>
          <div class="t4">
            数据标注员被正式定义为“人工智能训练师”并纳入国家职业分类目录，成为当代新职业。
          </div>
        </div>
      </div>
    </div>
    <div class="w1280">
      <div class="title-bg-1">
        <div class="title">课程优势</div>
      </div>
      <div class="flexs">
        <div v-for="(item, index) in ysList" :key="index" class="items">
          <div>
            <img :src="item.img" alt="" />
            <div class="t5">{{ item.title }}</div>
            <div class="t6">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="w1280">
      <div class="title-bg-2">
        <div class="title">全方位视频课程随时观看</div>
      </div>
      <div class="flexs">
        <div class="t7">闭环教学服务，摆脱低效学习</div>
        <div class="t7">与众多企业深度合作，保障课程契合企业刚需</div>
        <div class="t7">课程支持反复学习，教辅系统驱动教学更高效</div>
      </div>
      <div class="flexs">
        <div class="card-2" v-for="(item, index) in keList" :key="index" @click="go('/callMe')">
          <img style="width: 100%;" :src="item.img" alt="" />
          <div style="padding:16px 32px;">
            <div class="tt1">{{ item.title }}</div>
            <div class="tt2">{{ item.num }}人已学习</div>
          </div>
        </div>
      </div>
    </div>
    <div class="w1280">
      <div class="title-bg-3">
        <div class="title">学员真实评价</div>
      </div>
      <el-carousel
        :interval="4000"
        type="card"
        height="400px"
        style="width: 100%;"
      >
        <el-carousel-item
          v-for="(item, index) in lbList"
          :key="index"
          class="lb-item"
        >
          <img
            style="width: 128px;border-radius: 50%;background-color: aqua;"
            :src="item.img"
            alt=""
          />
          <span class="lb-name">{{ item.name }}</span>
          <div>
            <i
              class="el-icon-chat-dot-square "
              style="font-size: 48px;color: #099fee;"
            ></i>
          </div>
          <div class="lb-title">{{ item.title }}</div>
          <div class="lb-content">{{ item.content }}</div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="footers">
      <div class="w1280" style="padding-top: 48px;">
        <div class="title-bg-4">
          <div class="title">助力学员就业</div>
        </div>
        <div class="footers-content">
          高含金量证书帮助学员好就业
        </div>
        <div class="footers-content" style="text-align: right;margin-top: 64px;float: right;">
          优秀学员直接进入闽江数据标注基地
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lbList: [
        {
          img: require("../assets/img/rcpx/head1.png"),
          name: "小新同学",
          title: "加持证书",
          content:
            "通过在一系列学习后，参加了数据标注职业技能等级证书的等级考试，该证书得到许多企业的认可，为我以后标注职业的发展打下夯实的基础。",
        },
        {
          img: require("../assets/img/rcpx/head2.png"),
          name: "欢欢同学",
          title: "一学就会",
          content:
            "平台内容新颖，标注类型多，不但融合了当下最新教学理念大观念，还整合了其他的各种优质资源，理论与实操一体的课程设计让学习变得简单高效。",
        },
        {
          img: require("../assets/img/rcpx/head3.png"),
          name: "小鹿同学",
          title: "就业广泛",
          content:
            "在这里，我学到了数据标注相关知识，掌握了数据标注的能力，在就业中更加具有竞争力，在学习结束后，我被评为优秀学员加入了数据兼职标注团队，实现了在家也能接单赚钱。",
        },
      ],
      keList: [
        {
          title: "第一节   数据标注行业现状",
          num: 4103,
          img: require("../assets/img/rcpx/a1.png"),
        },
        {
          title: "第二节   数据标注概述",
          num: 3619,
          img: require("../assets/img/rcpx/a2.png"),
        },
        {
          title: "第三节  数据标注的应用场景",
          num: 2857,
          img: require("../assets/img/rcpx/a3.png"),
        },
        {
          title: "第四节   数据标注的基本要素",
          num: 3278,
          img: require("../assets/img/rcpx/a4.png"),
        },
      ],
      ysList: [
        {
          title: "初、中、高级课程",
          img: require("../assets/img/rcpx/k1.png"),
          content: "精细划分不同阶段的数据标注能力需求",
        },
        {
          title: "系统化进阶",
          img: require("../assets/img/rcpx/k2.png"),
          content: "每个阶段针对性指导潜心培养实战人才",
        },
        {
          title: "一站式学习",
          img: require("../assets/img/rcpx/k3.png"),
          content: "课程+真实实训项目一站式学习及时验证学习成果",
        },
        {
          title: "名师课程研发",
          img: require("../assets/img/rcpx/k1.png"),
          content: "高校名师联合研发的专业课程紧贴市场主流技术",
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.rcpx {
  .w1280 {
    width: 1280px;
    margin: 0 auto;
  }
  .footers {
    margin-top: 120px;
    background-image: url("../assets/img/rcpx/footer.png");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 700px;
    width: 100%;
  }
  .lb-item {
    padding: 32px;
    height: 350px;
    box-shadow: 7px 10px 27px 0 rgba(0, 0, 0, 0.08);
    border-radius: 32px;
    padding-bottom: 20px;
    background-color: #fff;
    width: 700px;
  }
  .lb-name {
    font-size: 28px;
    font-weight: 700px;
  }
  .lb-title {
    height: 35px;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1d1d1f;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .lb-content {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #1d1d1f;
    line-height: 36px;
  }
  .items {
    text-align: center;
    width: 280px;
    .t5 {
      font-size: 32px;
      margin-bottom: 20px;
      font-weight: 400;
      color: #1d1d1f;
    }
    .t6 {
      font-size: 20px;
      margin-bottom: 60px;
      font-weight: 300;
      line-height: 1.5;
      color: #1d1d1f;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-2 {
      margin-bottom: 48px;
      cursor: pointer;
      width: 310px;
      height: 300px;
      background: #fff;
      box-shadow: 7px 10px 27px 0 rgba(0, 0, 0, 0.08);
      border-radius: 32px;
      .tt1 {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #1d1d1f;
        line-height: 21px;
      }
      .tt2 {
        margin-top: 32px;
        font-size: 16px;
        text-align: right !important;
      }
    }
    .t7 {
      font-size: 20px;
      margin: 60px 0 100px 0;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        border-radius: 8px;
        top: 8px;
        left: -30px;
        background: #099fee;
      }
    }
    .left-s {
      width: 48%;
    }
    .right-s {
      width: 45%;
      .t3 {
        position: relative;
        font-size: 36px;
        font-weight: 700;
        color: #1d1d1f;
        &::before {
          content: "";
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          top: 20px;
          left: -40px;
          background: #099fee;
        }
      }
      .t4 {
        font-size: 18px;
        font-weight: 400;
        color: #1d1d1f;
        margin-bottom: 30px;
      }
    }
  }
  .footers-content{
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #fff;
    margin-top: 24px;
    position: relative;
    line-height: 80px;
    width: 600px;
    &::before{
      content: "";
      position: absolute;
      width: 200px;
      height: 80px;
      top: 0px;
      left: -40px;
      background: linear-gradient(135deg, rgba(49, 98, 244, 0.633) 0%, rgba(19, 208, 229, 0.05) 100%);
    }
  }
  .title-bg-4 {
    background-image: url(../assets/img/rcpx/bnr4.png);

    background-position: center;
    background-repeat: no-repeat;
    margin-top: 100px;
    height: 74px;
    margin-bottom: 100px;
    .title {
      font-size: 42px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      line-height: 104px;
    }
  }
  .title-bg-3 {
    background-image: url(../assets/img/rcpx/bnr3.png);

    background-position: center;
    background-repeat: no-repeat;
    margin-top: 100px;
    height: 74px;
    margin-bottom: 100px;
    .title {
      font-size: 42px;
      font-weight: 700;
      color: #1d1d1f;
      text-align: center;
      line-height: 104px;
    }
  }
  .title-bg-2 {
    background-image: url(../assets/img/rcpx/bnr2.png);
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 100px;
    height: 74px;
    margin-bottom: 100px;
    .title {
      font-size: 42px;
      font-weight: 700;
      color: #1d1d1f;
      text-align: center;
      line-height: 104px;
    }
  }
  .title-bg-1 {
    background-image: url(../assets/img/rcpx/bnr1.png);
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 100px;
    height: 74px;
    margin-bottom: 100px;
    .title {
      font-size: 42px;
      font-weight: 700;
      color: #1d1d1f;
      text-align: center;
      line-height: 104px;
    }
  }
  .title-bg {
    background-image: url(../assets/img/rcpx/bnr.png);
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 100px;
    height: 74px;
    margin-bottom: 100px;
    .title {
      font-size: 42px;
      font-weight: 700;
      color: #1d1d1f;
      text-align: center;
      line-height: 104px;
    }
  }
  .banners {
    height: 480px;
    background: url(../assets/img/rcpx/banner.png) no-repeat center center;
    background-size: cover;

    .t1 {
      font-size: 48px;
      padding-top: 60px;
      color: #fff;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .t2 {
      font-size: 24px;
      color: #fff;
      line-height: 1.5;
    }
    .btns {
      cursor: pointer;
      background-color: #099fee;
      line-height: 48px;
      height: 48px;
      border-radius: 8px;
      width: 240px;
      text-align: center;
      margin-top: 60px;
      color: #fff;
      font-size: 24px;
    }
  }
}
</style>
